module.exports = __webpack_public_path__ + "img/update100-01.667ff9cf.svg";